module.exports = __webpack_public_path__ + "static/media/Battle_of_the_Bots.3bbb4f8f.pdf";